(function () {
  function findActivePackPriceText(breaksContainer) {
    const checkedRadio = breaksContainer.querySelector('input[name="quantity"]:checked');
    const label = checkedRadio?.labels?.[0];
    if (!label) return null;

    const toggle = label.querySelector('gochi-subscribe-toggle');
    const priceRow = toggle?.querySelector('.gochi-subscribe-toggle__price-row');
    if (priceRow && !priceRow.hidden) {
      const newPriceEl = priceRow.querySelector('.gochi-subscribe-toggle__price-new');
      if (newPriceEl?.textContent.trim()) return newPriceEl.textContent.trim();
    }

    const basePriceEl = label.querySelector('.quantity-break__price');
    return basePriceEl?.textContent.trim() || null;
  }

  function updatePriceElement(el, newNumericText) {
    // Prefer Shopify's own price-item text nodes when present (the "separate price"
    // sticky display uses the full `render 'price'` snippet, which has nested markup —
    // scanning its raw innerHTML risks matching digits inside a class name/attribute
    // instead of the actual visible price, which is what caused this to silently fail).
    const priceItems = el.querySelectorAll('.price-item--regular, .price-item--sale, .price-item');
    if (priceItems.length > 0) {
      priceItems.forEach((item) => {
        const match = item.textContent.match(/[\d.,]+/);
        if (match) item.textContent = item.textContent.replace(match[0], newNumericText);
      });
      return;
    }
    // Plain-text fallback (e.g. the in-button price span with no nested markup) — safe
    // to match directly on textContent since it can't contain any tag/attribute text.
    const match = el.textContent.match(/[\d.,]+/);
    if (match) el.textContent = el.textContent.replace(match[0], newNumericText);
  }

  function syncStickyPrices(breaksContainer) {
    const priceText = findActivePackPriceText(breaksContainer);
    if (!priceText) return;
    const match = priceText.match(/[\d.,]+/);
    if (!match) return;

    document
      .querySelectorAll('[id^="sticky-atc-price-"], [id^="sticky-atc-separate-price-"]')
      .forEach((el) => updatePriceElement(el, match[0]));
  }

  document.querySelectorAll('quantity-breaks').forEach((breaksContainer) => {
    syncStickyPrices(breaksContainer);
    breaksContainer.addEventListener('change', (event) => {
      if (event.target.name === 'quantity') syncStickyPrices(breaksContainer);
    });
    breaksContainer.addEventListener('gochi-subscribe-toggle:change', () => {
      syncStickyPrices(breaksContainer);
    });

    // The theme's own bundle-expansion logic (which cart submission depends on to
    // correctly split a pack into per-cup line items) appears to only initialize in
    // response to a real "change" event on the quantity radios. The server-preselected
    // pack is already checked on load, so it never naturally fires one — meaning the
    // very first add-to-cart on that pack can submit incorrectly. Force one synthetic
    // change event after everything has settled, so its internal state is always ready.
    setTimeout(() => {
      const checkedRadio = breaksContainer.querySelector('input[name="quantity"]:checked');
      checkedRadio?.dispatchEvent(new Event('change', { bubbles: true }));
    }, 250);
  });
})();
